import React from 'react'
import PropTypes from 'prop-types'
import Truncate from 'react-truncate-markup'
import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'
import { useSelector } from 'react-redux'

// components
import CardBody from '../cardBody'
import FavouriteIndicator from '../favouriteIndicator'

const ListingInfo = (props) => {
  const { listingUuid, query } = props
  const listing = useSelector((state) => state.lots.listings[listingUuid])
  if (!listing) return null
  const auctionPath = listing.isMarketplace ? '/marketplace' : `/auctions/${listing.auctionUuid}`
  const listingLink = `${auctionPath}/listings/${listingUuid}${query}`
  return (
    <CardBody className='lot__info' key='listing-info__body'>
      <h3 className='lot__heading--title h5'>
        <FavouriteIndicator
          listingUuid={listingUuid}
        />
        {listing.title
          ? (<strong className='lot__info--title'><Link to={listingLink}>{listing.title}</Link></strong>)
          : null
        }
      </h3>
      {listing.summary
        ? (
          <h6 className='text-muted lot__info--summary'>
            <Truncate lines={4}>
              <span>
                {ReactHtmlParser(listing.summary)}
              </span>
            </Truncate>
          </h6>
          )
        : null}
    </CardBody>
  )
}

ListingInfo.propTypes = {
  currentLanguageCode: PropTypes.string, // eslint-disable-line react/no-unused-prop-types -- memo prop from parent; not read in body
  listingUuid: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired
}

export default React.memo(ListingInfo)
